import React from 'react';
import PostCard from './PostCard';

const Dashboard = ({ posts, analysisData, onReset }) => {
  const opportunityTypes = posts.reduce((acc, post) => {
    acc[post.opportunity_type] = (acc[post.opportunity_type] || 0) + 1;
    return acc;
  }, {});

  const averageRelevance = posts.length > 0 
    ? (posts.reduce((sum, post) => sum + post.relevance_score, 0) / posts.length).toFixed(1)
    : 0;

  return (
    <div>
      <div className="dark-card rounded-lg p-6 shadow-lg mb-8">
        <h3 className="text-xl font-bold mb-4 dark-text">Analysis Results</h3>
        <p className="dark-text-secondary mb-2">
          Found <strong className="dark-text">{analysisData.total_found}</strong> relevant engagement opportunities 
          for "{analysisData.company_description}" across {analysisData.subreddits.length} subreddits.
        </p>
        <p className="dark-text-secondary mb-2">
          <strong className="dark-text">Monitored subreddits:</strong> {analysisData.subreddits.map(sub => `r/${sub}`).join(', ')}
        </p>
        <p className="dark-text-secondary mb-4">
          <strong className="dark-text">Average relevance score:</strong> {averageRelevance}/10
        </p>
        
        <div className="mb-6">
          <strong className="dark-text block mb-2">Opportunity types found:</strong>
          <ul className="dark-text-secondary space-y-1">
            {Object.entries(opportunityTypes).map(([type, count]) => (
              <li key={type} className="flex items-center">
                <span className="w-2 h-2 bg-purple-400 rounded-full mr-2"></span>
                {type}: {count} posts
              </li>
            ))}
          </ul>
        </div>
        
        <button 
          onClick={onReset}
          className="gradient-bg text-white px-6 py-2 rounded-lg font-medium hover:shadow-lg transition-all duration-200"
        >
          New Search
        </button>
      </div>

      {posts.length === 0 ? (
        <div className="dark-card rounded-lg p-8 shadow-lg text-center">
          <p className="dark-text-muted">No relevant posts found. Try adjusting your company description or adding more subreddits.</p>
        </div>
      ) : (
        <div>
          <h3 className="text-xl font-bold dark-text mb-6">Engagement Opportunities</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {posts.map((post, index) => (
              <PostCard key={post.id || index} post={post} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard; 